.imagePreviewContainer {
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: center;
	align-items: center;
	gap: 0.75rem;

	&:focus-visible {
		outline: 2px solid var(--focus-outline-color-dark);
		outline-offset: 2px;
	}
}

.imgContainerButton {
	cursor: pointer;
	border: none;
	background: none;

	&:focus-visible {
		outline: 2px solid var(--focus-outline-color-dark);
		outline-offset: 2px;
	}

	&:hover {
		background-color: #f4f4f4;
	}
}

.imageWrapper {
	border-radius: 6px;
	position: relative;
}

.imagePreview {
	object-fit: contain;
	width: 100%;
	height: 100%;
}

.fileName:global(.MuiTypography-root) {
	color: #202124;
	font-size: 0.875rem;
	line-height: 1.6;
	font-weight: 500;
	max-width: 100%;
	text-align: center;
}

.fallbackContainer {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.75rem;
	height: 100%;
	width: 100%;
}
